import { CoObjectTypeEnum } from "../models";
import { axiosInstance } from "../../utils/axios";
import { PagedResult } from "./PageResult";

export interface ObjectComponentInfoItem {
  objectLogicId: string;
  type: CoObjectTypeEnum;
  objectName: string;
  documentName: string;
  documentId: string;
}

export interface ObjectComponentInfoItemPage {
  componentTOList: ObjectComponentInfoItem[];
}

export async function fetchObjectComponentInfoItems(
  searchValue: string,
  currentPage: number,
  pageSize: number
): Promise<PagedResult<ObjectComponentInfoItemPage>> {
  let response = await axiosInstance.get(`/components?name=${searchValue}&page=${currentPage}&size=${pageSize}`);
  return await response.data;
}
